import type { MetaProperties } from './Avo';
import type { MetaPropertiesGetter } from '../../types';
import type { App } from '../../../App';

export class AvoMetaPropertiesGetter implements MetaPropertiesGetter {
  constructor(private readonly app: App) {}

  public getMetaProperties(properties?: MetaProperties[] | undefined): MetaProperties[] | null {
    const {
      stateController,
      controller: { sceneManager },
    } = this.app;

    const result: MetaProperties[] = [
      ...(properties ?? []),
      {
        metaPropertyName: 'Highest Level',
        metaPropertyValue: `${stateController.getLevelNumber()}`,
      },
      {
        metaPropertyName: 'Coin Balance',
        metaPropertyValue: `${stateController.getCoins()}`,
      },
    ];

    const { levelAttemptId } = stateController.getLevelTrackingData();

    if (levelAttemptId !== '' && sceneManager?.activeScene?.id === 'Game') {
      result.push({
        metaPropertyName: 'Level Attempt Id',
        metaPropertyValue: levelAttemptId,
      });
    }

    return result;
  }
}
